import { getBacklogFields, type BacklogFieldCount } from "../../../lib/corpusApi";
import { useAsyncData } from "../../../hooks/useAsyncData";

export interface UseAnnotationLandingResult {
  fields: BacklogFieldCount[];
  total: number;
  loading: boolean;
  error: string | null;
}

/** Fetches the blocking Tier-1 field breakdown for the Annotation landing page. */
export function useAnnotationLanding(): UseAnnotationLandingResult {
  const { data, loading, error } = useAsyncData(async () => {
    const res = await getBacklogFields();
    return res.fields;
  });

  const fields = data ?? [];
  const total = fields.reduce((sum, f) => sum + f.count, 0);

  return { fields, total, loading, error };
}
